import BaseStyle from '@primevue/core/base/style';

export default BaseStyle.extend({
    name: 'inputswitch'
});
